<template>
    <page :title="pageTitle">
        <transition name="page" mode="out-in">
            <form @submit.prevent="resetPassword" v-if="!sent" :key="sent">
                <div class="row">
                    <div class="col-sm-8 offset-sm-2">
                        <div class="form-group">
                            <label for="email">{{ $t('account_email') }}</label>
                            <input v-model="formData.email"
                                   id="email"
                                   type="email"
                                   class="form-control">
                            <div class="form-control-feedback">
                              {{ $t('pwd_enterEmail') }}
                            </div>
                        </div>
                        <div class="center">
                            <div class="form-group-btn">
                                <button type="submit" :disabled="!formData.email" class="btn btn-primary pull-right">{{ $t('pwd_sendEmail') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="row text-center" v-if="sent" :key="sent">
                <div class="col-md-8 offset-md-2">
                    <p>{{ $t('account_emailSent_p1') }}: {{ formData.email }}</p>
                    <p>{{ $t('account_emailSent_p2') }}</p>
                    <p>{{ $t('account_emailSent_p3') }}</p>
                    <p>{{ $t('account_emailSent_p4') }}</p>
                    <button class="btn btn-primary" @click="resetPassword">{{ $t('pwd_resendEmail') }}</button>
                </div>
            </div>
        </transition>
    </page>
</template>

<script>
import Page from './utilities/Page'
import { API } from '../api/axios'

export default {
  name: 'PasswordRecovery',
  components: {Page},
  data () {
    return {
      formData: {
        email: '',
      },
      sent: false,
    }
  },
  computed: {
    pageTitle () {
      return this.sent ? this.$t('pwd_pwdRecovered') : this.$t('pwd_pwdRecovery')
    },
  },
  methods: {
    resetPassword () {
      // API.post('/users/forgotpassword', this.formData)
      API.post(`/users/forgotpassword?email=${this.formData.email}`)
        .then(response => {
          console.log('Password reset response', response)
        })
        .catch(error => {
          console.error('Password reset error', error)
        })
        .then(() => (this.sent = true))
    },
  },
}
</script>

<style scoped>
    .page-enter-active, .page-leave-active {
        transition: opacity .3s;
    }

    .page-enter, .page-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/PasswordRecovery.vue